import React, {
  forwardRef,
  useRef,
  useCallback,
  useEffect,
  useImperativeHandle,
} from 'react';

import styledC from 'styled-components';

import { ComponentIconProps } from '../types';

const RingBackgroundSvg = styledC.svg`
  width: 100%;
  height: 100%;
  fill: rgba(0, 0, 0, 0.1);
`;

const RingFillSvg = styledC.svg<{ $darkColor: string; $lightColor: string }>`
  width: 100%;
  height: 100%;

  path {
    opacity: 0;
    fill: ${(props) => props.$darkColor};

    &:nth-of-type(2n) {
      fill: ${(props) => props.$lightColor};
    }
  }
`;

type SvgData = {
  viewBox: string;
  backgroundPath: string;
  fillPaths: string[];
};

const getSvgDataForSize = (size: number): SvgData => {
  if (size <= 16) {
    return {
      viewBox: '0 0 16 16',
      backgroundPath:
        'M1.07 4L8 0L14.93 4V12L8 16L1.07 12V4ZM8 12.54L11.93 10.27V5.73L8 3.46L4.07 5.73V10.27L8 12.54Z',
      fillPaths: [
        'M8 3.46V0L1.07 4V4L8 3.46V3.46Z',
        'M4.07 5.72999L8 3.45999L1.07 3.99999V3.99999L4.07 5.72999V5.72999Z',
        'M4.07 5.73L1.07 4V12V12L4.07 5.73V5.73Z',
        'M4.07 10.27V5.73001L1.07 12V12L4.07 10.27V10.27Z',
        'M4.07 10.27L1.07 12L8 16V16L4.07 10.27V10.27Z',
        'M8 12.54L4.07 10.27L8 16V16V12.54V12.54Z',
        'M8 12.54V16L14.93 12V12L8 12.54V12.54Z',
        'M11.93 10.27L8 12.54L14.93 12V12L11.93 10.27V10.27Z',
        'M11.93 10.27L14.93 12V4V4L11.93 10.27V10.27Z',
        'M11.93 5.73V10.27L14.93 4V4L11.93 5.73V5.73Z',
        'M11.93 5.73L14.93 4L8 0V0L11.93 5.73V5.73Z',
        'M8 3.46L11.93 5.73L8 0V0V3.46V3.46Z',
      ],
    };
  } else if (size <= 24) {
    return {
      viewBox: '0 0 24 24',
      backgroundPath:
        'M12 0L20.49 3.51L24 12L20.49 20.49L12 24L3.51 20.49L0 12L3.51 3.51L12 0ZM12 19.67L17.42 17.42L19.67 12L17.42 6.58L12 4.33L6.58 6.58L4.33 12L6.58 17.42L12 19.67Z',
      fillPaths: [
        'M3.52 3.52L12 4.33V0L3.52 3.52Z',
        'M3.52 3.51999L6.58 6.57999L12 4.32999L3.52 3.51999Z',
        'M0 12L6.58 6.57999L3.52 3.51999L0 12Z',
        'M0 12H4.33L6.58 6.57999L0 12Z',
        'M3.52 20.48L4.33 12H0L3.52 20.48Z',
        'M3.52 20.48L6.58 17.42L4.33 12L3.52 20.48Z',
        'M12 24L6.58 17.42L3.52 20.48L12 24Z',
        'M12 24V19.67L6.58 17.42L12 24Z',
        'M20.48 20.48L12 19.67V24L20.48 20.48Z',
        'M20.48 20.48L17.42 17.42L12 19.67L20.48 20.48Z',
        'M24 12L17.42 17.42L20.48 20.48L24 12Z',
        'M24 12H19.67L17.42 17.42L24 12Z',
        'M20.48 3.51999L19.67 12H24L20.48 3.51999Z',
        'M20.48 3.51999L17.42 6.57999L19.67 12L20.48 3.51999Z',
        'M12 0L17.42 6.58L20.48 3.52L12 0Z',
        'M12 0V4.33L17.42 6.58L12 0Z',
      ],
    };
  } else {
    return {
      viewBox: '0 0 216 216',
      backgroundPath:
        'M108 0L171.48 20.63L210.71 74.63V141.37L171.48 195.37L108 216L44.52 195.38L5.28998 141.38V74.63L44.52 20.63L108 0ZM159 178.15L190.48 134.8L190.5 81.2L159 37.85L108 21.29L57 37.85L25.5 81.21V134.8L57 178.15L108 194.71L159 178.15Z',
      fillPaths: [
        'M108 21.2962V0L44.5162 20.6213L108 21.2962Z',
        'M108 21.2962L44.5162 20.6212L57.0375 37.8506L108 21.2962Z',
        'M57.0375 37.8506L44.5162 20.6212L5.28186 74.6212L57.0375 37.8506Z',
        'M57.0375 37.8506L5.28186 74.6212L25.5319 81.2025L57.0375 37.8506Z',
        'M25.5319 81.2025L5.28186 74.6212V141.379L25.5319 81.2025Z  ',
        'M25.5319 81.2025L5.28186 141.379L25.5319 134.798V81.2025Z',
        'M25.5319 134.797L5.28186 141.379L44.5162 195.379L25.5319 134.797Z',
        'M25.5319 134.797L44.5162 195.379L57.0375 178.149L25.5319 134.797Z',
        'M57.0375 178.149L44.5162 195.379L108 216L57.0375 178.149Z',
        'M57.0375 178.149L108 216V194.704L57.0375 178.149Z',
        'M108 194.704V216L171.484 195.379L108 194.704Z',
        'M108 194.704L171.484 195.379L158.963 178.149L108 194.704Z',
        'M158.962 178.149L171.484 195.379L210.718 141.379L158.962 178.149Z',
        'M158.962 178.149L210.718 141.379L190.468 134.797L158.962 178.149Z',
        'M190.468 134.797L210.718 141.379V74.6212L190.468 134.797Z',
        'M190.468 134.797L210.718 74.6212L190.468 81.2025V134.797Z',
        'M190.468 81.2025L210.718 74.6212L171.484 20.6212L190.468 81.2025Z',
        'M190.468 81.2025L171.484 20.6212L158.962 37.8506L190.468 81.2025Z',
        'M158.963 37.8506L171.484 20.6213L108 0L158.963 37.8506Z',
        'M158.963 37.8506L108 0V21.2962L158.963 37.8506Z',
      ],
    };
  }
};

const Container = styledC.div`
  position: relative;
  display: inline-block;
`;

const SvgWrapper = styledC.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
`;

interface WeaveProgressRingProps extends ComponentIconProps {
  indeterminate?: boolean;
  colorDark?: string;
  colorLight?: string;
  now?: number;
  alternative?: boolean;
}

const MAX_PERCENTAGE = 100;
const CYCLE_ANIMATION_DURATION = 1000;
const FADE_DURATION = 416;
const OPACITY_DECREASE_FACTOR = 100 / FADE_DURATION;

const WeaveProgressRing = forwardRef<HTMLDivElement, WeaveProgressRingProps>(
  (
    {
      size = 24,
      colorDark = 'currentColor',
      colorLight = 'currentColor',
      indeterminate = true,
      now = 0,
      alternative: _alternative,
      className,
    },
    ref,
  ) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const previousPercentage = useRef<number>(0);
    const animationFrameRequest = useRef<number | undefined>(undefined);

    const queryFragments = useCallback(
      (): NodeListOf<SVGPathElement> | null =>
        containerRef.current?.querySelectorAll<SVGPathElement>(
          '.weave-progress-ring-fill path',
        ) || null,
      [],
    );

    const cancelCurrentAnimation = useCallback(() => {
      if (animationFrameRequest.current) {
        cancelAnimationFrame(animationFrameRequest.current);
      }
    }, []);

    const updateFragmentsOpacity = useCallback(
      (fragments: NodeListOf<SVGPathElement>, currentPercentage: number) => {
        const fragmentCount = fragments.length;
        const percentagePerFragment = MAX_PERCENTAGE / fragmentCount;
        const completedFragmentsCount = Math.floor(
          currentPercentage / percentagePerFragment,
        );
        const completedFragmentsPercentage =
          completedFragmentsCount * percentagePerFragment;
        const middleFragmentOpacity =
          (currentPercentage - completedFragmentsPercentage) /
          percentagePerFragment;

        fragments.forEach((fragment, index) => {
          const indexRelativeToLast = Math.abs(fragmentCount - index) - 1;

          if (indexRelativeToLast < completedFragmentsCount) {
            fragment.style.opacity = '1';
          } else if (indexRelativeToLast === completedFragmentsCount) {
            fragment.style.opacity = `${middleFragmentOpacity}`;
          } else {
            fragment.style.opacity = '0';
          }
        });
      },
      [],
    );

    const animateDeterminateProgress = useCallback(
      (finalPercentage: number) => {
        const fragments = queryFragments();
        if (!fragments) return;

        const percentageDifference = Math.abs(
          finalPercentage - previousPercentage.current,
        );
        const previousFinalPercentage = previousPercentage.current;
        const startTime = performance.now();
        const duration = Math.max(
          1,
          Math.floor(
            CYCLE_ANIMATION_DURATION * (percentageDifference / MAX_PERCENTAGE),
          ),
        );

        const animateFrame = (time: number) => {
          const animationProgress = Math.min((time - startTime) / duration, 1);
          const currentPercentage = Math.min(
            percentageDifference * animationProgress + previousFinalPercentage,
            finalPercentage,
          );

          updateFragmentsOpacity(fragments, currentPercentage);
          previousPercentage.current = currentPercentage;

          const hasFinishedAnimation = currentPercentage === finalPercentage;
          if (!hasFinishedAnimation) {
            animationFrameRequest.current = requestAnimationFrame(animateFrame);
          }
        };

        animationFrameRequest.current = requestAnimationFrame(animateFrame);
      },
      [queryFragments, updateFragmentsOpacity],
    );

    const updateIndeterminateFragmentsOpacity = useCallback(
      (fragments: NodeListOf<SVGPathElement>, cycleTime: number) => {
        const fragmentCount = fragments.length;
        const durationPerFragment = CYCLE_ANIMATION_DURATION / fragmentCount;

        fragments.forEach((fragment, index) => {
          const indexRelativeToLast = Math.abs(fragmentCount - index) - 1;
          const startFadeTime = indexRelativeToLast * durationPerFragment;

          let timeDifference = cycleTime - startFadeTime;
          if (timeDifference < 0) {
            timeDifference =
              CYCLE_ANIMATION_DURATION - (startFadeTime - cycleTime);
          }

          const opacity =
            timeDifference > FADE_DURATION
              ? 0
              : 100 - timeDifference * OPACITY_DECREASE_FACTOR;

          fragment.style.opacity = `${opacity}%`;
        });
      },
      [],
    );

    const animateIndeterminateProgress = useCallback(() => {
      const fragments = queryFragments();
      if (!fragments) return;

      const startTime = performance.now();
      const animateFrame = (time: number) => {
        const cycleTime = (time - startTime) % CYCLE_ANIMATION_DURATION;
        updateIndeterminateFragmentsOpacity(fragments, cycleTime);

        animationFrameRequest.current = requestAnimationFrame(animateFrame);
      };

      animationFrameRequest.current = requestAnimationFrame(animateFrame);
    }, [queryFragments, updateIndeterminateFragmentsOpacity]);

    useEffect(() => {
      cancelCurrentAnimation();

      if (indeterminate) {
        animateIndeterminateProgress();
      } else {
        animateDeterminateProgress(Math.min(now, 100));
      }

      return () => cancelCurrentAnimation();
    }, [
      now,
      indeterminate,
      animateDeterminateProgress,
      animateIndeterminateProgress,
      cancelCurrentAnimation,
    ]);

    useImperativeHandle(ref, () => containerRef.current as HTMLDivElement);

    const svgData = getSvgDataForSize(size);

    return (
      <Container
        ref={containerRef}
        className={className}
        style={{
          width: size,
          height: size,
        }}
      >
        <SvgWrapper>
          <RingFillSvg
            $darkColor={colorDark}
            $lightColor={colorLight}
            className="weave-progress-ring-fill"
            viewBox={svgData.viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {svgData.fillPaths.map((d, index) => (
              <path key={index} d={d} />
            ))}
          </RingFillSvg>
        </SvgWrapper>
        <SvgWrapper>
          <RingBackgroundSvg
            className="weave-progress-ring-background"
            viewBox={svgData.viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d={svgData.backgroundPath} />
          </RingBackgroundSvg>
        </SvgWrapper>
      </Container>
    );
  },
);

WeaveProgressRing.displayName = 'WeaveProgressRing';

export default WeaveProgressRing;
